import React, { FC } from 'react';
import Image from 'next/image';
import { useTranslation } from "next-i18next";

import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';

import Markdown from 'markdown-to-jsx';
import PlayYoutube from './YoutubePlayer';
import MDLink from './MDLink';

interface IMarkDownProps {
    content: string;
    locale: string;
}

const MarkDown: FC<IMarkDownProps> = (props: IMarkDownProps) => {
    const { content, locale } = props;
    const theme = useTheme();
    const { t } = useTranslation('common');


    const options = {
        overrides: {
            h1: { component: Typography, props: { gutterBottom: true, variant: 'h1', }, },
            h2: { component: Typography, props: { gutterBottom: true, variant: 'h2' } },
            h3: { component: Typography, props: { gutterBottom: true, variant: 'h3' } },
            h4: { component: Typography, props: { gutterBottom: true, variant: 'h4' }, },
            h5: { component: Typography, props: { gutterBottom: true, variant: 'h5' } },
            h6: { component: Typography, props: { gutterBottom: true, variant: 'caption' } },
            p: { component: Typography, props: { paragraph: true } },
            a: { component: MDLink, props: { locale: locale } },
            li: { component: ListItem, props: {  sx: { pl:0, pt:0, display:'list-item', listStylePosition: 'inside' } } },
            img: { component: Image, props: { width: 450, height: 300, layout: 'responsive' }, },
            Youtube: { component: PlayYoutube, props: { width: '100%', height: 300, ...props }, },
            APPname: { component: Typography, props: { children: process.env.appName, variant: 'span' }, },
            APPurl: { component: Typography, props: { children: process.env.appUrl, variant: 'span' }, }
        },
    };

    return (
        <Markdown options={options}>
            {content}
        </Markdown>
    )
}

export default MarkDown;